import React, { useState, useMemo} from "react";
import styled from 'styled-components'
import QueryTable from "./QueryTable";

const GameScheduleTable = (props) => {

  const [show, setShow] = useState(false);
  const [valueSelected, setValueSelected] = useState({})
  const [modalType, setModalType] = useState()

    // table styles.  Taken from an example.  Investigate porting to css.  Produces warnings.

    const Wrapper = styled.section`
        padding: 0em;
        padding-top: 0rem;
        padding-bottom: 0rem;
        background: white;
        text-align: left;
        align-items: center;
        alignItems: center;
    `;
    const Styles = styled.div`
        padding: 1rem;

        .table {
          display: inline-block;
          border-spacing: 0;
          border: 1px solid #ccc;;

          .tr {
            :last-child {
              .td {
                ${'' /* border-bottom: 0; */}
                border-bottom: 1px solid #ccc;
              }
            }
          }

          .th {
            margin: 0;
            padding: .5rem;
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
            color:  #00447c;
            font-weight: 600;

            :last-child {
              border-right: 1px solid #ccc;
            }
          }


          .td {
            margin: 0;
            padding: .5rem;
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
            white-space: nowrap;
            text-overflow:ellipsis;
            overflow: hidden;

            :last-child {
              border-right: 1px solid #ccc;
            }
          }
        }
      `

  // apply fixed format to host average_rating

  function toFixedFormat (value) {
    return parseFloat(isNaN(value) ? 0 : value).toFixed(2)
  }

  // simple array to map columns for table.


  const columns = useMemo(
    () => [
      {
        Header: () => (
            <span style={{display: "none"}} ></span>
        ),
        id: 'someId',
        columns: [

          {
            Header: "Date",
            accessor: "schedule_date",
            Cell: ({row}) => {
                const dataValue = row.original
                const showGameInformation = () => {
                    setValueSelected(dataValue.game_schedule_id)
                    setModalType("game contact")
                    setShow(true)
                }
            return (
                <div onClick={()=> showGameInformation()} > {dataValue.schedule_date} </div>
            )
            }
          },
          {
            Header: "Time",
            accessor: "schedule_time",
            Cell: ({row}) => {
                const dataValue = row.original
                const showGameInformation = () => {
                    setValueSelected(dataValue.game_schedule_id)
                    setModalType("game contact")
                    setShow(true)
                }
            return (
                <div onClick={()=> showGameInformation()} > {dataValue.local_time} </div>
            )
            }
          },
          {
            Header: "Game",
            accessor: "game_name",
            Cell: ({row}) => {
                const dataValue = row.original
                const showGameInformation = () => {
                    setValueSelected(dataValue.game_schedule_id)
                    setModalType("game contact")
                    setShow(true)
                }
            return (
                <div onClick={()=> showGameInformation()} > {dataValue.game_name} </div>
            )
            }
          },
          {
            Header: "Community",
            accessor: "community_name",
            width: 332,
            Cell: ({row}) => {
                const dataValue = row.original
                const showGameInformation = () => {
                    setValueSelected(dataValue.game_schedule_id)
                    setModalType("game contact")
                    setShow(true)
                }
            return (
                <div onClick={()=> showGameInformation()} > {dataValue.community_name} </div>
            )
            }
          },
          {
            Header: "Scheduled Host",
            accessor: "host_name",
            width: 200,
            Cell: ({row}) => {
                const dataValue = row.original
                const showHostInformation = () => {
                    setValueSelected(dataValue.game_schedule_id)
                    setModalType("host contact")
                    setShow(true)
                }
            return (
                <div onClick={()=> showHostInformation()} > {dataValue.host_name} </div>
            )
            }
          },
          {
            Header: "Rating",
            accessor: "host_average_rating",
            width: 95,
            Cell: ({row}) => {
                const dataValue = row.original
                const showHostInformation = () => {
                    setValueSelected(dataValue.game_schedule_id)
                    setModalType("host contact")
                    setShow(true)
                }
            return (
                <div onClick={()=> showHostInformation()} > {toFixedFormat(dataValue.host_average_rating)} </div>
            )
            }
          },
          {
            Header: "Fee",
            accessor: "host_fee",
            width: 90,
            Cell: ({row}) => {
                const dataValue = row.original
                const showHostInformation = () => {
                    setValueSelected(dataValue.game_schedule_id)
                    setModalType("host contact")
                    setShow(true)
                }
            return (
                <div onClick={()=> showHostInformation()} > {toFixedFormat(dataValue.host_fee)} </div>
            )
            }
          },
        ]
      },
    ],
    []
  );
  return (
      <Wrapper>
        <Styles>
            <QueryTable
              columns={columns}
              data={props.data}
              caller={props.caller}
              setRefresh={props.setRefresh}
              refresh={props.refresh}
              setShow={setShow}
              show={show}
              valueSelected={valueSelected}
              modalType={modalType}
               />
        </Styles>
    </Wrapper>
  );
}

export default GameScheduleTable;